import { lazy } from "react";
import OrderRoute from "./OrderRoute";
import OtpRouteGuard from "./OtpRouteGuard";
const AllProductList = lazy(() => import("../pages/AllProductList"));
const CheckoutGuard = lazy(() => import("./CheckoutGuard"));
const PrivateRoute = lazy(() => import("./PrivateRoute"));
const HappyClientPage = lazy(() => import("../pages/HappyClientPage"));
const ProfilePage = lazy(() => import("../pages/ProfilePage"));
const OrdersPage = lazy(() => import("../pages/OrdersPage"));
const AboutPage = lazy(() => import("../pages/AboutPage"));
const ThankYouPage = lazy(() => import("../pages/ThankYouPage"));
const MainLayout = lazy(() => import("../layouts/MainLayout"));
const AuthLayout = lazy(() => import("../layouts/AuthLayout"));
const CartPage = lazy(() => import("../pages/CartPage"));
const CheckoutPage = lazy(() => import("../pages/CheckoutPage"));
const ContactPage = lazy(() => import("../pages/ContactPage"));
const HomePage = lazy(() => import("../pages/HomePage"));
const LoginPage = lazy(() => import("../pages/LoginPage"));
const ProductDetailsPage = lazy(() => import("../pages/ProductDetailsPage"));
const RegisterPage = lazy(() => import("../pages/RegisterPage"));
const ResetPasswordPage = lazy(() => import("../pages/ResetPasswordPage"));
const VerifyOTPPage = lazy(() => import("../pages/VerifyOTPPage"));
const OrderDetailPage = lazy(() => import("../pages/OrderDetailPage"));
const RulesPolicy = lazy(() => import("../pages/RulesPolicy"));
const PageNotFoundPage = lazy(() => import("../pages/PageNotFound"));
const AllBrands = lazy(() => import("../pages/AllBrands"));

export const routes = [
  {
    id: "1001",
    path: "/",
    element: (
      <MainLayout>
        <HomePage />
      </MainLayout>
    ),
    public: true,
  },
  {
    id: "1019",
    path: "/all-brands",
    element: (
      <MainLayout>
        <AllBrands />
      </MainLayout>
    ),
    public: true,
  },
  {
    id: "1002",
    path: "/cart",
    element: (
      <MainLayout>
        <CartPage />
      </MainLayout>
    ),
    public: true,
  },
  {
    id: "1003",
    path: "/product-detail/:slug/:id",
    element: (
      <MainLayout>
        <ProductDetailsPage />
      </MainLayout>
    ),
    public: true,
  },
  {
    id: "1004",
    path: "/checkout",
    element: (
      <MainLayout>
        <PrivateRoute>
          <CheckoutGuard>
            <CheckoutPage />
          </CheckoutGuard>
        </PrivateRoute>
      </MainLayout>
    ),
    public: true,
  },
  {
    id: "1005",
    path: "/thank-you",
    element: (
      <OrderRoute>
        <MainLayout>
          <ThankYouPage />
        </MainLayout>
      </OrderRoute>
    ),
    public: true,
  },
  {
    id: "1006",
    path: "/user-account",
    element: (
      <PrivateRoute>
        <MainLayout>
          <ProfilePage />
        </MainLayout>
      </PrivateRoute>
    ),
    public: true,
  },
  {
    id: "1007",
    path: "/orders-list",
    element: (
      <PrivateRoute>
        <MainLayout>
          <OrdersPage />
        </MainLayout>
      </PrivateRoute>
    ),
    public: true,
  },
  {
    id: "1008",
    path: "/contact",
    element: (
      <MainLayout>
        <ContactPage />
      </MainLayout>
    ),
    public: true,
  },
  {
    id: "1009",
    path: "/about-us",
    element: (
      <MainLayout>
        <AboutPage />
      </MainLayout>
    ),
    public: true,
  },
  {
    id: "1010",
    path: "/testimonials",
    element: (
      <MainLayout>
        <HappyClientPage />
      </MainLayout>
    ),
    public: true,
  },
  {
    id: "1011",
    path: "/rules-policy",
    element: (
      <MainLayout>
        <RulesPolicy />
      </MainLayout>
    ),
    public: true,
  },
  {
    id: "1012",
    path: "/login",
    element: (
      <AuthLayout>
        <LoginPage />
      </AuthLayout>
    ),
    public: true,
  },
  {
    id: "1013",
    path: "/register",
    element: (
      <AuthLayout>
        <RegisterPage />
      </AuthLayout>
    ),
    public: true,
  },
  {
    id: "1014",
    path: "/verify-otp",
    element: (
      <AuthLayout>
        <OtpRouteGuard>
          <VerifyOTPPage />
        </OtpRouteGuard>
      </AuthLayout>
    ),
    public: true,
  },
  {
    id: "1015",
    path: "/reset-password/:token/",
    element: (
      <AuthLayout>
        <ResetPasswordPage />
      </AuthLayout>
    ),
    public: true,
  },
  {
    id: "1016",
    path: "/shop",
    element: (
      <MainLayout>
        <AllProductList />
      </MainLayout>
    ),
    public: true,
  },
  {
    id: "1020",
    path: "/products",
    element: (
      <MainLayout>
        <AllProductList />
      </MainLayout>
    ),
    public: true,
  },
  {
    id: "1017",
    path: "/orders-list/:id",
    element: (
      <MainLayout>
        <OrderDetailPage />
      </MainLayout>
    ),
    public: true,
  },
  {
    id: "1018",
    path: "*",
    element: (
      <MainLayout>
        <PageNotFoundPage />
      </MainLayout>
    ),
    public: true,
  },
];
